<template>
	<div>
		<div class="search-GAdata">
			<el-select
				v-model="associatedAccount"
				placeholder="请选择关联主账号"
				size="medium"
				class="search-select"
				clearable
				@change="selectChange"
				:loading="optionsList.length == 0 ? true : false"
			>
				<el-option
					v-for="item in optionsList"
					:key="item.id"
					:label="title == 'GA4' ? `${item.value}(${item.quantity})` : item.value"
					:value="item.id"
					:disabled="item.quantity >= 100 && title == 'GA4'"
				></el-option>
			</el-select>
			<div class="search-input-btn">
				<el-input
					v-model="gaKeyWords"
					autofocus
					@keyup.enter.native="searchGA"
					size="medium"
					class="search-input"
					:placeholder="placeholder"
					@input="inputChange"
				></el-input>
				<el-button size="medium" type="primary" @click="searchGA">搜索</el-button>
			</div>
		</div>
		<data-list
			:table-style="{ name: 'mixture' }"
			maxHeight="500"
			highlight-current-row
			:data="data"
			:columns="gaColumn"
			:loading="gaListLoading"
			@current-change="getRow"
		></data-list>
	</div>
</template>
<script>
export default {
	props: ['optionsList', 'data', 'gaColumn', 'gaListLoading', 'title'],
	data() {
		return {
			associatedAccount: '',
			gaKeyWords: '',
		};
	},
	computed: {
		placeholder() {
			let { title } = this;
			if (title == 'GTM') {
				return '输入GTM账号ID';
			} else {
				return `输入客户名或${title}-ID（默认填写公司名称）`;
			}
		},
	},
	methods: {
		selectChange(val) {
			this.$emit('selectChange', val);
		},
		inputChange(val) {
			this.$emit('inputChange', val);
		},
		searchGA() {
			this.$emit('searchGA');
		},
		getRow(row) {
			this.$emit('getRow', row);
		},
	},
	components: {},
};
</script>
<style scoped lang="scss">
.search-GAdata {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 40px;

	.search-select {
		width: 250px;
		margin-right: 5%;
	}

	.search-input-btn {
		flex: 1;
		display: flex;
		justify-content: flex-start;

		.search-input {
			margin-right: 10px;
		}
	}
}
</style>
